module.exports = __webpack_public_path__ + "img/2x.6241244.jpg";